/**
 * Позволяет хранить и получать режим для дебаггера из queryParams с фоллбеком на localStorage
 */
export class DebuggerMode {
  constructor(private params: DebuggerParams) {}

  getMode() {
    try {
      const locationMode = this.locationMode()

      switch (locationMode) {
        case Mode.DISABLED:
        case Mode.ENABLED_COLLAPSE:
        case Mode.ENABLED: {
          this.saveMode(locationMode)
          return locationMode
        }

        default: {
          return this.getSavedMode()
        }
      }
    } catch {
      return Mode.DISABLED
    }
  }

  private getSavedMode() {
    try {
      return this.parseMode(localStorage.getItem(this.params.key))
    } catch (error) {
      console.error(error)
      return Mode.DISABLED
    }
  }

  private saveMode(value: Mode) {
    try {
      localStorage.setItem(this.params.key, String(value))
    } catch (error) {
      console.error(error)
    }
  }

  private locationMode() {
    try {
      let url: URL
      try {
        url = new URL(window.parent.location.href)
      } catch {
        // фоллбек для случаев когда мы не можем обращаться к window.parent
        // например при просмотре вебвизора метрики
        url = new URL(window.location.href)
      }

      const value = url.searchParams.get(this.params.key)

      return this.parseMode(value)
    } catch {
      return Mode.DISABLED
    }
  }

  private parseMode(value: unknown) {
    try {
      const parsed = Number.parseInt(String(value))

      switch (parsed) {
        case Mode.DISABLED:
        case Mode.ENABLED_COLLAPSE:
        case Mode.ENABLED: {
          return parsed
        }

        default: {
          return Mode.DEFAULT
        }
      }
    } catch {
      return Mode.DISABLED
    }
  }
}

export enum Mode {
  ENABLED = 1,
  ENABLED_COLLAPSE = 2,
  DISABLED = 0,
  DEFAULT = -1
}

type DebuggerParams = {
  /** Название ключа в localStorage а также название параметра в url, рекомендуется формат `_{name}_debug` */
  key: string
}
